import { render, staticRenderFns } from "./Topics.vue?vue&type=template&id=5bffd5f6&scoped=true"
import script from "./Topics.vue?vue&type=script&lang=js"
export * from "./Topics.vue?vue&type=script&lang=js"
import style0 from "./Topics.vue?vue&type=style&index=0&id=5bffd5f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bffd5f6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogChip: require('/home/rohit/Documents/GitHub/aibuddha-website/components/blog/chip.vue').default})
